import { Helmet } from "react-helmet-async";
import FunnelLayout from "@/v2/components/FunnelLayout";

const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy - Progetto Startup</title>
        <meta name="description" content="Cookie Policy di Progetto Startup - Come utilizziamo i cookie sul nostro sito" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <FunnelLayout>
        <div className="max-w-3xl mx-auto">
          <article className="prose prose-invert max-w-none text-slate-300">
            <h1 className="text-white text-4xl font-bold mb-2">Cookie Policy</h1>
            <p className="text-slate-500 mb-8">Ultimo aggiornamento: Luglio 2026</p>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Cosa sono i cookie</h2>
              <p>Strumenti utilizzati per migliorare navigazione, analizzare traffico e personalizzare contenuti.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Tipologie di cookie utilizzati</h2>

              <div className="mb-6">
                <h3 className="text-slate-200 text-xl font-semibold mb-2">1. Cookie tecnici – necessari</h3>
                <p className="mb-2"><strong>Sempre attivi.</strong> Servono a:</p>
                <ul className="space-y-1">
                  <li>Navigazione</li>
                  <li>Sicurezza</li>
                  <li>Funzionamento login</li>
                  <li>Salvataggio preferenze minime</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-slate-200 text-xl font-semibold mb-2">2. Cookie analitici (solo con consenso)</h3>
                <p className="mb-2"><strong>Esempi:</strong> Google Analytics 4, Hotjar</p>
                <p className="mb-2">Utilizzati per:</p>
                <ul className="space-y-1">
                  <li>Analisi comportamento aggregato</li>
                  <li>Miglioramento UX</li>
                  <li>Statistiche</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-slate-200 text-xl font-semibold mb-2">3. Cookie di marketing (solo con consenso)</h3>
                <p className="mb-2"><strong>Esempi:</strong> Meta Pixel</p>
                <p className="mb-2">Utilizzati per:</p>
                <ul className="space-y-1">
                  <li>Misurare campagne</li>
                  <li>Remarketing</li>
                  <li>Pubblicità personalizzata</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Gestione del consenso</h2>
              <p className="mb-4">In linea con GDPR, i cookie NON necessari vengono attivati solo dopo:</p>
              <ul className="space-y-2">
                <li>Click su "Accetta" nel banner</li>
                <li>Modifica preferenze nel "Centro Preferenze Cookie"</li>
              </ul>
              <p className="mt-4">È sempre possibile modificare le preferenze tramite il pulsante fisso <strong>"Preferenze cookie"</strong>.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Durata dei cookie</h2>
              <ul className="space-y-2">
                <li><strong>Tecnici:</strong> sessione / 1 anno</li>
                <li><strong>Analitici:</strong> 1–24 mesi</li>
                <li><strong>Marketing:</strong> 1–6 mesi</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Come disattivare i cookie</h2>
              <p className="mb-2">Puoi farlo:</p>
              <ul className="space-y-2">
                <li>Dal pulsante "Preferenze cookie"</li>
                <li>Dal browser</li>
                <li>Eliminando cookie e cache</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Contatti</h2>
              <p className="mb-2">
                <a href="mailto:ciao@progettostartup.com" className="text-orange-400 hover:text-orange-300">ciao@progettostartup.com</a>
              </p>
              <p>Federico Piccinini Group – REA 226475</p>
            </section>
          </article>
        </div>
      </FunnelLayout>
    </>
  );
};

export default CookiePolicy;
